import React from "react";
import { Typography, CardMedia, Box, useTheme } from "@mui/material";
import { getCardStyles, imageStyles } from "./styles";

interface IProps {
  title: string;
  iconUrl: string;
  description: string;
}

const TrackmateCard: React.FC<IProps> = ({ title, iconUrl, description }) => {
  const theme = useTheme();

  return (
    <Box sx={getCardStyles(theme)}>
      <Box>
        <CardMedia
          component="img"
          image={iconUrl}
          alt={title}
          sx={imageStyles}
        />
        <Typography variant="h4" component="h3" color="text.primary">
          {title}
        </Typography>
      </Box>
      <Typography variant="subtitle1" color="text.secondary">
        {description}
      </Typography>
    </Box>
  );
};

export default TrackmateCard;
